import {
  Divider,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  Tag,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { FirebaseConfig, FirebaseCourseItem } from '../../types/types';

interface CourseItemPopoverProps {
  course: FirebaseCourseItem;
  category?: string;
  config: FirebaseConfig;
}

export const CourseItemPopover: React.FC<CourseItemPopoverProps> = ({
  course,
  category,
  config,
}) => (
  <PopoverContent borderRadius="xl" boxShadow="xl">
    <PopoverCloseButton />
    <PopoverBody>
      <Text mb={1} fontWeight="bold">
        Trainer*in
      </Text>
      <Text>{course.trainer.ids[0]}</Text>
      <Divider my={3} />
      <Text fontWeight="bold" mb={1}>
        Beschreibung
      </Text>
      <Text>{course.description}</Text>
      {course.roomName && (
        <>
          <Divider my={3} />
          <Text fontWeight="bold">Ort</Text>
          <Text>{course.roomName}</Text>
        </>
      )}
      {category && (
        <>
          <Divider my={3} />
          <Text mb={1} fontWeight="bold">
            Kategorie
          </Text>
          <Text>{category}</Text>
        </>
      )}
      <Divider my={3} />
      <Text mb={1}>
        {course.isOnline && <Tag m={1}>Online-Kurs</Tag>}
        {course.canRegister && (
          <Tag m={1}>Studio-Kurs (max. {course.maxParticipants})</Tag>
        )}
      </Text>
    </PopoverBody>
  </PopoverContent>
);
